import React, { useState } from "react";
import "../styles/LeadForm.css";
import { useNavigate } from "react-router-dom";

const LeadForm = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [title, setTitle] = useState("");
  const [budget, setBudget] = useState("");
  const [business, setBusiness] = useState("");
  const [audience, setAudience] = useState("");
  const [services, setServices] = useState("");
  const [platforms, setPlatforms] = useState("");
  const [referral, setReferral] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    const formData = {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      email: email.trim(),
      phone: phone.trim(),
      company: company.trim(),
      title: title.trim(),
      budget,
      business: business.trim(),
      audience: audience.trim(),
      services,
      platforms,
      referral,
    };

    try {
      //  const response = await fetch('http://localhost:5000/send-email', {
        const response = await fetch("https://growth-lab-backend.onrender.com/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        navigate("/thank-you");
      } else {
        alert(data.message || "There was an error submitting the form.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="lead-form-section">
      <div className="form-heading">
        <h1 id="form-h1">
          Get Your <span className="form-highlight">FREE</span> Audit Today!
        </h1>
        <h2 className="form-sub-heading">Fill out the form below!</h2>
      </div>

      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                id="firstName"
                placeholder="e.g., 'John'"
                name="firstName"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                placeholder="e.g., 'Smith'"
                name="lastName"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="company">Company</label>
              <input
                type="text"
                id="company"
                placeholder="e.g., 'Smith Construction'"
                name="company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="title">Title</label>
              <input
                type="text"
                id="title"
                placeholder="e.g., 'Marketing Manager'"
                name="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="email">Company Email*</label>
              <input
                type="email"
                id="email"
                placeholder="e.g., 'john@example.com'"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone*</label>
              <input
                type="tel"
                id="phone"
                placeholder="e.g., '555-555-5555'"
                name="phone"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
              <small>Format: 555-555-5555</small>
            </div>
          </div>

          <div className="form-group">
            <label>What Is Your Monthly Marketing Budget?</label>
            <select
              name="budget"
              value={budget}
              onChange={(e) => setBudget(e.target.value)}
            >
              <option value="">- Please Select -</option>
              <option value="1k-5k">$1,000 - $5,000</option>
              <option value="5k-10k">$5,000 - $10,000</option>
              <option value="10k+">$10,000+</option>
            </select>
          </div>

          <div className="form-group">
            <label>Tell Us About Your Business</label>
            <textarea
              placeholder="Placeholder"
              name="business"
              value={business}
              onChange={(e) => setBusiness(e.target.value)}
            ></textarea>
          </div>

          <div className="form-group">
            <label>Tell Us About Your Audience</label>
            <textarea
              placeholder="Placeholder"
              name="audience"
              value={audience}
              onChange={(e) => setAudience(e.target.value)}
            ></textarea>
          </div>

          <div className="form-group">
            <label>What Services Are You Most Interested In?</label>
            <select
              name="services"
              value={services}
              onChange={(e) => setServices(e.target.value)}
            >
              <option value="">- Please Select -</option>
              <option value="strategy">Strategy Consulting</option>
              <option value="advertising">Advertising Services</option>
            </select>
          </div>

          <div className="form-group">
            <label>What Platforms Are You Actively Marketing On?</label>
            <select
              name="platforms"
              value={platforms}
              onChange={(e) => setPlatforms(e.target.value)}
            >
              <option value="">- Please Select -</option>
              <option value="google">Google Ads</option>
              <option value="facebook">Facebook</option>
              <option value="linkedin">LinkedIn</option>
            </select>
          </div>

          <div className="form-group">
            <label>How Did You Hear About Us?</label>
            <select
              name="referral"
              value={referral}
              onChange={(e) => setReferral(e.target.value)}
            >
              <option value="">- Please Select -</option>
              <option value="search">Search Engine</option>
              <option value="social">Social Media</option>
              <option value="referral">Referral</option>
            </select>
          </div>

          <button type="submit" className="submit-button" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default LeadForm;